import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carousel.css";
import "./brandItems.css";

const Branditems = () => {
  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 6,
    autoplay: false, // Enable autoplay
    autoplaySpeed: 1500,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="container">
        <div className="branditems-heading container pt-4 pb-3">
          <h2 className="title-branditems">Top Brands For You</h2>
        </div>
        <div className="img-container container">
          <div className="row">
            <Slider {...settings}>
              <a href="">
                <div className="col-lg-3 col-md-3 brand-items-img">
                  <div className="wrapper-brand-img ">
                    <img
                      src="https://im.idiva.com/content/2020/Sep/Fast-Food-Chain-Logo_1_5f50d6242b804.jpg?w=1200&h=900&cc=1 "
                      alt=""
                    />
                  </div>
                  <p className="img-name">McDonald's</p>
                  <p className="img-time">29 min</p>
                </div>{" "}
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3 brand-items-img">
                  <div className="wrapper-brand-img ">
                    <img
                      src="https://b.zmtcdn.com/data/brand_creatives/logos/1b51d0bca33e149302056def63fb5fa3_1536924805.png"
                      alt=""
                    />
                  </div>
                  <p className="img-name">La pino'z</p>
                  <p className="img-time">15 min</p>
                </div>{" "}
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3  brand-items-img">
                  <div className="wrapper-brand-img ">
                    <img
                      src="https://img.freepik.com/premium-vector/logo-fast-food-restaurant-company-brand-business-marketing_686210-21.jpg?w=2000"
                      alt=""
                    />
                  </div>
                  <p className="img-name">Fast Food</p>
                  <p className="img-time">20 min</p>
                </div>{" "}
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3  brand-items-img">
                  <div className="wrapper-brand-img ">
                    <img
                      src="https://i.pinimg.com/236x/5d/c3/ca/5dc3cae64ecb116dd17aefdf8a969da0--closest-pizza-pizza-cheese.jpg"
                      alt=""
                    />
                  </div>

                  <p className="img-name">Pizza Hut</p>
                  <p className="img-time">30 min</p>
                </div>{" "}
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3  brand-items-img">
                  <div className="wrapper-brand-img ">
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFv93s35X_8_9WGWiMF3HKy9V83E6DUo5hXhbEeiDhRTQ-FtxGtrvS0mpfIv7OT6w3C8Q&usqp=CAU"
                      alt=""
                    />
                  </div>
                  <p className="img-name">KFC</p>
                  <p className="img-time">40 min</p>
                </div>{" "}
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3  brand-items-img">
                  <div className="wrapper-brand-img ">
                    <img
                      src="https://i.pinimg.com/564x/58/05/77/58057737c65c0eba4ec9224bb891d7bb.jpg"
                      alt=""
                    />
                  </div>
                  <p className="img-name">Domino's</p>
                  <p className="img-time">60 min</p>
                </div>{" "}
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3  brand-items-img">
                  <div className="wrapper-brand-img ">
                    <img
                      src="https://im.idiva.com/content/2020/Sep/Fast-Food-Chain-Logo_4_5f50d6a7f2119.jpg?w=1200&h=900&cc=1"
                      alt=""
                    />
                  </div>
                  <p className="img-name">Albaik</p>
                  <p className="img-time">10 min</p>
                </div>{" "}
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3  brand-items-img">
                  <div className="wrapper-brand-img ">
                    <img
                      src="https://content.jdmagicbox.com/comp/bhopal/d5/0755px755.x755.150101195326.f7d5/catalogue/balaji-restaurant-bhel-bhopal-home-delivery-restaurants-rqebtznl88-250.jpg"
                      alt=""
                    />
                  </div>
                  <p className="img-name">Balaji</p>
                  <p className="img-time">30 min</p>
                </div>{" "}
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3  brand-items-img">
                  <div className="wrapper-brand-img ">
                    <img
                      src="https://www.shutterstock.com/shutterstock/photos/2259550473/display_1500/stock-vector-biryani-rice-indian-food-vector-illustration-logo-2259550473.jpg"
                      alt=""
                    />
                  </div>
                  <p className="img-name">Traditional</p>
                  <p className="img-time">40 min</p>
                </div>{" "}
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3  brand-items-img">
                  <div className="wrapper-brand-img ">
                    <img
                      src="https://previews.123rf.com/images/sandzcreative/sandzcreative2108/sandzcreative210800088/173742903-pani-puri-food-logo-vector-illustration-indian-street-food-traditional-culinary-for-business.jpg"
                      alt=""
                    />
                  </div>
                  <p className="img-name">Indian Pani Puri</p>
                  <p className="img-time">20min</p>
                </div>
              </a>
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default Branditems;
